import { message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Select, Form as FormInitial } from "antd";
import {
  ModalItem,
  FormItem,
  ButtonItem,
  InputItem,
  ErrorItem,
  SelectItem,
  Form,
  HeaderItem,
  BoxItem,
  cuentaMask,
  SwitchItem,
} from "../../../../Components/Items";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import SelectClientesItem from "../../../../Components/SelectClientesItem";

const { Option } = Select;

class AgregarCaja extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    todasBancos: [],
    todasProyectos: [],
    objetoProyectos: [],
    objetoClientes: [],
    todasClientes: [],
    objetoPrecios: [],
    todasPrecios: [],
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.consultarTodo();
      setTimeout(() => {
        if (this.formRef.current) {
          this.formRef.current.setFieldsValue({
            bancoTarjeta: [undefined] // Inicializa con un campo vacío
          });
        }
      }, 100);
    }
  }

  onFinishFailed(e) {
    ErrorItem(e);
  };

  consultarTodo() {
    this.setState({ loading: true });
    axios
      .post(
        "cajas/selectDatosParaCaja",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.formRef.current.setFieldsValue({ codigo: res.data.nuevoCodigo, bancoTarjeta: [undefined] })
          this.setState({
            todasBancos: res.data.bancos.map((banco) => (
              <Option key={banco._id} value={banco._id}>
                {banco.nombre}
              </Option>
            )),
            todasPrecios: res.data.precios.precios.map((precio) => (
              <Option key={precio._id} value={precio._id}>
                {precio.nombre}
              </Option>
            )),
            objetoProyectos: res.data.proyectos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            objetoCuentaContable: res.data.cuentasContablesFinales.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                  ) +
                    " - " +
                    value.descripcion}
                </Option>
              );
            }),
          });
        } else {
          message.error("No se encontro informacion");
        }
      });
  }

  onFinish(values) {
    if (values?.bancoTarjeta?.length === 0) {
      return message.error("Debe seleccionar al menos un banco de tarjeta");
    }
    if (values?.nombre) {
      this.setState({ loading: true });
      axios
        .post(
          "cajas/agregarCaja",
          {
            ...values,
            empresaId: this.props.empresaId,
          },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          this.setState({ loading: false });
          if (res.data.success === 2) {
            message.success("Caja agregada exitosamente");
            this.cerrarAgregarCaja();
          } else if (res.data.success === 1) {
            message.error("No se pudo agregar la caja");
          } else {
            message.error("Sucedió un error y no se pudo agregar la caja");
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
          message.error("Error al comunicarse con el servidor");
        });
    } else {
      message.info("Proporcione al menos el nombre de la cirugia");
    }
  }


  cerrarAgregarCaja = () => {
    this.props.cerrarAgregarCaja();
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
  };

  render() {
    return (
      <ModalItem
        title="Agregar Caja"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarAgregarCaja.bind(this)}
      >
        <Form
          ref={this.formRef}
          name="modalAgregarCaja"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}
            >
              Guardar
            </ButtonItem>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormItem
            name="codigo"
            label="Número de Caja"
            required
            margin
          >
            <InputItem disabled placeholder="Ingresa el número de Caja" />
          </FormItem>


          <FormItem
            name="nombre"
            label="Caja"
            required
            margin
          >
            <InputItem placeholder="Ingresa el nombre de la caja" />
          </FormItem>
          <FormItem
            name="proyectoId"
            label="Proyecto"
            required
            margin
          >
            <SelectItem placeholder="Elija el Proyecto">
              {this.state.objetoProyectos}
            </SelectItem>
          </FormItem>
          <FormItem
            name="clienteId"
            label="Cliente Por Defecto"
            required
            margin
          >
            <SelectClientesItem
              empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
              headersToken={this.props.headersToken}
              sinBorde
              autoFocus
              dropdownMatchSelectWidth={600}
              width="100%"
              placeholder="Elija el Cliente"
            />
          </FormItem>
          <FormItem
            name="precioId"
            label="Precios"
            required
            margin
          >
            <SelectItem placeholder="Elija el Precio">
              {this.state.todasPrecios}
            </SelectItem>
          </FormItem>
          <FormItem
            name="listaCliente"
            label="Usar lista del cliente"
            margin
            initialValue={false}
            valuePropName="checked"
            tooltip = "Se usará la lista por defecto que el cliente tenga definida como precio de menudeo"
          >
            <SwitchItem />
          </FormItem>
          <FormItem
            name="bancoEfectivo"
            label="Banco Efectivo"
            required
            margin
          >
            <SelectItem placeholder="Elija el banco">
              {this.state.todasBancos}
            </SelectItem>
          </FormItem>
          <FormItem
            name="bancoVales"
            label="Banco Vales"
            required
            margin
          >
            <SelectItem placeholder="Elija el banco">
              {this.state.todasBancos}
            </SelectItem>
          </FormItem>
          <FormItem
            name="bancoCheques"
            label="Banco Cheques"
            required
            margin
          >
            <SelectItem placeholder="Elija el banco">
              {this.state.todasBancos}
            </SelectItem>
          </FormItem>
          <FormItem
            name="bancoTransferencia"
            label="Banco Transferencia"
            required
            margin
          >
            <SelectItem placeholder="Elija el banco">
              {this.state.todasBancos}
            </SelectItem>
          </FormItem>
          <HeaderItem>Tarjeta</HeaderItem>
          <BoxItem>
            <FormInitial.List name="bancoTarjeta">
              {(fields, { add, remove }) => (
                <div style={{ marginBottom: 24 }}>
                  {fields.map((field, index) => (
                    <div key={field.key} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                      <FormItem
                        {...field}
                        label="Banco Tarjeta"
                        name={field.name}
                        required
                        fieldKey={field.fieldKey}
                        style={{ flex: 1, marginBottom: 0, marginRight: 8 }}
                      >
                        <SelectItem placeholder="Elija el banco">
                          {this.state.todasBancos}
                        </SelectItem>
                      </FormItem>


                      {fields.length > 1 && (
                        <ButtonItem
                          onClick={() => remove(field.name)}
                          icon={<MinusCircleOutlined />}
                          style={{
                            color: '#999999',
                            border: 'none',
                            boxShadow: 'none',
                            padding: '4px'
                          }}
                        />
                      )}
                    </div>
                  ))}

                  <ButtonItem
                    type="dashed"
                    onClick={() => add()}
                    icon={<PlusOutlined />}
                    block
                    style={{ marginTop: 8 }}
                  >
                    Agregar Banco
                  </ButtonItem>
                </div>
              )}
            </FormInitial.List>
          </BoxItem>
          <HeaderItem>Retiros o Depósitos</HeaderItem>
          <BoxItem>
            <FormInitial.List name="cajasRetiros">
              {(fields, { add, remove }) => (
                <div style={{ marginBottom: 24 }}>
                  {fields.map((field, index) => (
                    <div key={field.key} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                      <FormItem
                        {...field}
                        label="Banco/Caja Retiros"
                        name={field.name}
                        required
                        fieldKey={field.fieldKey}
                        style={{ flex: 1, marginBottom: 0, marginRight: 8 }}
                      >
                        <SelectItem placeholder="Elija el banco / caja">
                          {this.state.todasBancos}
                        </SelectItem>
                      </FormItem>


                      {fields.length > 1 && (
                        <ButtonItem
                          onClick={() => remove(field.name)}
                          icon={<MinusCircleOutlined />}
                          style={{
                            color: '#999999',
                            border: 'none',
                            boxShadow: 'none',
                            padding: '4px'
                          }}
                        />
                      )}
                    </div>
                  ))}

                  <ButtonItem
                    type="dashed"
                    onClick={() => add()}
                    icon={<PlusOutlined />}
                    block
                    style={{ marginTop: 8 }}
                  >
                    Agregar Banco/Caja Retiros
                  </ButtonItem>
                </div>
              )}
            </FormInitial.List>
            <FormInitial.List name="cajasIngresos">
              {(fields, { add, remove }) => (
                <div style={{ marginBottom: 24 }}>
                  {fields.map((field, index) => (
                    <div key={field.key} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                      <FormItem
                        {...field}
                        label="Banco/Caja Ingresos"
                        name={field.name}
                        required
                        fieldKey={field.fieldKey}
                        style={{ flex: 1, marginBottom: 0, marginRight: 8 }}
                      >
                        <SelectItem placeholder="Elija el banco / caja">
                          {this.state.todasBancos}
                        </SelectItem>
                      </FormItem>


                      {fields.length > 1 && (
                        <ButtonItem
                          onClick={() => remove(field.name)}
                          icon={<MinusCircleOutlined />}
                          style={{
                            color: '#999999',
                            border: 'none',
                            boxShadow: 'none',
                            padding: '4px'
                          }}
                        />
                      )}
                    </div>
                  ))}

                  <ButtonItem
                    type="dashed"
                    onClick={() => add()}
                    icon={<PlusOutlined />}
                    block
                    style={{ marginTop: 8 }}
                  >
                    Agregar Banco/Caja Ingresos
                  </ButtonItem>
                </div>
              )}
            </FormInitial.List>
          </BoxItem>
          <HeaderItem>Cuentas Contables</HeaderItem>
          <BoxItem>
            <FormItem
              label="Permitir Otros Retiros"
              name="permitirOtrosRetiros"
              margin
              initialValue={false}
              valuePropName="checked"
              tooltip="Si esta activado, se pueden realizar otros retiros. (No recomendable)"
            >
              <SwitchItem />
            </FormItem>
            <FormItem shouldUpdate={(prevValues, currentValues) => prevValues.permitirOtrosRetiros !== currentValues.permitirOtrosRetiros} noStyle>
              {({ getFieldValue }) =>
                getFieldValue('permitirOtrosRetiros') && (
                  <FormItem name="cuentaContableRetiroId" label="Cuenta Contable Retiro" required margin>
                    <SelectItem placeholder="Cuenta Contable Retiro" width="100%">
                      {this.state.objetoCuentaContable}
                    </SelectItem>
                  </FormItem>
                )
              }
            </FormItem>
            <FormItem
              label="Permitir Otros Ingresos"
              name="permitirOtrosIngresos"
              margin
              initialValue={false}
              valuePropName="checked"
              tooltip="Si esta activado, se pueden realizar otros ingresos. (No recomendable)"
            >
              <SwitchItem />
            </FormItem>
            <FormItem shouldUpdate={(prevValues, currentValues) => prevValues.permitirOtrosIngresos !== currentValues.permitirOtrosIngresos} noStyle>
              {({ getFieldValue }) =>
                getFieldValue('permitirOtrosIngresos') && (
                  <FormItem name="cuentaContableDepositoId" label="Cuenta Contable Depósito" required margin>
                    <SelectItem placeholder="Cuenta Contable Depósito" width="100%">
                      {this.state.objetoCuentaContable}
                    </SelectItem>
                  </FormItem>
                )
              }
            </FormItem>
          </BoxItem>
          <HeaderItem>Impresión de Tickets</HeaderItem>
          <BoxItem>
            <FormItem
              label="Imprimir Ticket de Cobro"
              name="ticketCobro"
              margin
              initialValue={false}
              valuePropName="checked"
              tooltip="Si esta activado, se imprime el ticket de la factura."
            >
              <SwitchItem />
            </FormItem>
            <FormItem
              label="Imprimir Ticket de Factura"
              name="ticketFactura"
              margin
              initialValue={false}
              valuePropName="checked"
              tooltip="Si esta activado, se imprime el ticket de la factura."
            >
              <SwitchItem />
            </FormItem>
          </BoxItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(AgregarCaja);
